import { Box, Button, Grid, MobileStepper, useTheme } from "@mui/material";
import { useState } from "react";
import AccordianContainer from "../../../CustomComponents/AccordianContainer";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import CustomTextField from "../../../CustomComponents/CustomTextField";
import { convertDateWithValidation, validate } from "../../helper/losDataHelper";

const TechnicalPropertyAddressInformation = ({ technicalAddressInfoList }) => {

    const theme = useTheme();
  const [activeStep, setActiveStep] = useState(0);

 const maxSteps = validate(technicalAddressInfoList) ?  technicalAddressInfoList.length : 0;

 const handleBack = () => {
   setActiveStep((prevActiveStep) => prevActiveStep - 1);
 };

 const handleNext = () => {
   setActiveStep((prevActiveStep) => prevActiveStep + 1);

}

const technicalPropertyAddressInfoComponent = () => {
    const technicalPropAddressInfo = validate(technicalAddressInfoList) ? technicalAddressInfoList[activeStep] : undefined;
    return(
        <Grid container rowSpacing={0} columnSpacing={2}>
           <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Address ID"
                 variant="standard"
                 placeholder="Enter Address ID"
                 disabled={true}
                 value={technicalPropAddressInfo !== undefined ? technicalPropAddressInfo.addressId : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Internal Technical ID"
                 variant="standard"
                 placeholder="Enter Internal Technical ID"
                 disabled={true}
                 value={technicalPropAddressInfo !== undefined ? technicalPropAddressInfo.internalTechnicalId : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Internal Application ID"
                 variant="standard"
                 placeholder="Enter Internal Application ID"
                 disabled={true}
                 value={technicalPropAddressInfo !== undefined ? technicalPropAddressInfo.internalApplicationId : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Flat/Door/Building/Block"
                 variant="standard"
                 placeholder="Enter Flat/Door/Building/Block"
                 disabled={true}
                 value={technicalPropAddressInfo !== undefined ? technicalPropAddressInfo.flatDoorBuildingBlock : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Block Details"
                 variant="standard"
                 placeholder="Enter Block Details"
                 disabled={true}
                 value={technicalPropAddressInfo !== undefined ? technicalPropAddressInfo.blockDetails : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Road / Street"
                 variant="standard"
                 placeholder="Enter Road / Street"
                 disabled={true}
                 value={technicalPropAddressInfo !== undefined ? technicalPropAddressInfo.roadStreet : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Landmark"
                 variant="standard"
                 placeholder="Enter Landmark"
                 disabled={true}
                 value={technicalPropAddressInfo !== undefined ? technicalPropAddressInfo.landmark : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Location"
                 variant="standard"
                 placeholder="Enter Location"
                 disabled={true}
                 value={technicalPropAddressInfo !== undefined ? technicalPropAddressInfo.location : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Area / Locality"
                 variant="standard"
                 placeholder="Enter Area / Locality"
                 disabled={true}
                 value={technicalPropAddressInfo !== undefined ? technicalPropAddressInfo.areaLocality : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="City Code"
                 variant="standard"
                 placeholder="Enter City Code"
                 disabled={true}
                 value={technicalPropAddressInfo !== undefined ? technicalPropAddressInfo.cersaiCityCode : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="City"
                 variant="standard"
                 placeholder="Enter City"
                 disabled={true}
                 value={technicalPropAddressInfo !== undefined ? technicalPropAddressInfo.cersaiCity : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="City / Town"
                 variant="standard"
                 placeholder="Enter City / Town"
                 disabled={true}
                 value={technicalPropAddressInfo !== undefined ? technicalPropAddressInfo.cityTown : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="District Code"
                 variant="standard"
                 placeholder="Enter District Code"
                 disabled={true}
                 value={technicalPropAddressInfo !== undefined ? technicalPropAddressInfo.cersaiDistrictCode : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="District"
                 variant="standard"
                 placeholder="Enter District"
                 disabled={true}
                 value={technicalPropAddressInfo !== undefined ? technicalPropAddressInfo.cersaiDistrict : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="State"
                 variant="standard"
                 placeholder="Enter State"
                 disabled={true}
                 value={technicalPropAddressInfo !== undefined ? technicalPropAddressInfo.state : ""}
               />
               </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Country"
                 variant="standard"
                 placeholder="Enter Country"
                 disabled={true}
                 value={technicalPropAddressInfo !== undefined ? technicalPropAddressInfo.country : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomTextField
                 type="text"
                 label="Pincode"
                 variant="standard"
                 placeholder="Enter Pincode"
                 disabled={true}
                 value={technicalPropAddressInfo !== undefined ? technicalPropAddressInfo.pincode : ""}
               />
               </Grid>
               <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
               <CustomTextField
                  type="text"
                  label="Created By"
                  variant="standard"
                  placeholder="Enter Created By"
                  disabled={true}
                  value={ technicalPropAddressInfo !== undefined ? technicalPropAddressInfo.createdBy : ""}
                />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
               <CustomTextField
                  type="text"
                  label="Modified By"
                  variant="standard"
                  placeholder="Enter Modified By"
                  disabled={true}
                  value={technicalPropAddressInfo !== undefined ? technicalPropAddressInfo.modifiedBy : ""}
                />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
               <CustomTextField
                  type="text"
                  label="Created Date"
                  variant="standard"
                  placeholder="Enter Created Date"
                  disabled={true}
                  value={technicalPropAddressInfo !== undefined ? convertDateWithValidation(technicalPropAddressInfo.createdDate) : ""}
                />
                </Grid>
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
               <CustomTextField
                  type="text"
                  label="Modified Date"
                  variant="standard"
                  placeholder="Enter Modified Date"
                  disabled={true}
                  value={technicalPropAddressInfo !== undefined ? convertDateWithValidation(technicalPropAddressInfo.modifiedDate) : ""}
                />
                </Grid>
               </Grid>
      );
    }

    return(
        <AccordianContainer
        id="accord"
        title="Technical Property Address Information"
        initialOpen={false}
      >
      <Box sx={{ marginTop: "-1%" }}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Box sx={{ display: "flex", justifyContent:"center", alignItems: "center", marginBottom: "8px"}}>
                       { maxSteps > 1 && <MobileStepper
                         variant="text"
                         steps={maxSteps}
                         position="static"
                         activeStep={activeStep}
                         sx={{ maxWidth: 400, flexGrow: 1, boxShadow: 2 }} 
                           nextButton={
                           <Button size="small" sx={{ color:"#003f7c" }} onClick={handleNext} disabled={activeStep === maxSteps - 1}>
                               Next
                           {theme.direction === 'rtl' ? (
                           <KeyboardArrowLeft />
                           ) : ( <KeyboardArrowRight /> )}
                          </Button>
                        }
                       backButton={
                       <Button size="small" onClick={handleBack} sx={{ color:"#003f7c" }} disabled={activeStep === 0}>
                       {theme.direction === 'rtl' ? (
                           <KeyboardArrowRight />
                       ) : (
                           <KeyboardArrowLeft />
                       )}
                           Back
                       </Button>
                   }
                   /> }
                   </Box>
                   </Grid>
                   { technicalPropertyAddressInfoComponent() }
       </Box>
      </AccordianContainer>
     );

}

export default TechnicalPropertyAddressInformation;